import queryAnalyticsSettings from '@ms/yammer-graphql/dist/operations/queryAnalyticsSettings.graphql';

import { ManagedApiLifecycle, getGraphqlApiRequest, managedApiAction } from '../../api';
import { normalizeAnalyticsAdminSettings } from '../../normalization/graphql/normalizeAnalyticsAdminSettings';
import { reportError } from '../../telemetry/api';
import { PromiseThunkAction } from '../../types';

import {
  AnalyticsAdminSettingsFulfilledAction,
  AnalyticsAdminSettingsPendingAction,
  AnalyticsAdminSettingsRejectedAction,
  AnalyticsAdminSettingsResponse,
} from './loadActions.types';
import { getAnalyticsAdminSettingsStatus } from './selectors';

const loadAnalyticsAdminSettingsPending = (): AnalyticsAdminSettingsPendingAction => ({
  type: 'ANALYTICS_ADMIN_SETTINGS.LOAD_PENDING',
});

const loadAnalyticsAdminSettingsFulfilled = (
  payload: AnalyticsAdminSettingsFulfilledAction['payload']
): AnalyticsAdminSettingsFulfilledAction => ({
  type: 'ANALYTICS_ADMIN_SETTINGS.LOAD_FULFILLED',
  payload,
});

const loadAnalyticsAdminSettingsRejected = (error: unknown): AnalyticsAdminSettingsRejectedAction => ({
  type: 'ANALYTICS_ADMIN_SETTINGS.LOAD_REJECTED',
  payload: {
    error,
  },
  error: true,
});

const loadAnalyticsAdminSettingsRequest = () =>
  getGraphqlApiRequest({
    body: {
      operationName: 'AnalyticsSettings',
      query: queryAnalyticsSettings,
    },
  });

const loadAnalyticsAdminSettingsLifecycle: ManagedApiLifecycle<AnalyticsAdminSettingsResponse> = {
  pending: () => loadAnalyticsAdminSettingsPending(),
  fulfilled: (rawAnalyticsSettings) => {
    const payload = normalizeAnalyticsAdminSettings(rawAnalyticsSettings);

    return loadAnalyticsAdminSettingsFulfilled(payload);
  },
  rejected: (error) => loadAnalyticsAdminSettingsRejected(error),
};

type Load = () => PromiseThunkAction<void>;
export const load: Load = () => async (dispatch, getState) => {
  const state = getState();
  const status = getAnalyticsAdminSettingsStatus(state);

  if (status === 'pending') {
    return;
  }

  const action = managedApiAction({
    request: loadAnalyticsAdminSettingsRequest(),
    lifecycle: loadAnalyticsAdminSettingsLifecycle,
  });

  try {
    await dispatch(action);
  } catch (error) {
    reportError({
      error,
    });
  }
};
